import styled from 'styled-components';
import Button from '@material-ui/core/Button';

import { warnTextColor } from '../../../lib/theme';

// The theme `primary` lime reaches only 1.49:1 on the warning alert's pale
// orange — below even the 3:1 UI-component floor. A filled warnTextColor with
// white label is 5.50:1 (WCAG AA) and reads unmistakably as the action.
export const SwitchAccountButton = styled(Button)`
  && {
    background-color: ${warnTextColor};
    color: #fff;
    border: 1px solid ${warnTextColor};
    font-weight: 700;
    box-shadow: none;
  }

  &&:hover {
    background-color: #8f3900;
    border-color: #8f3900;
    box-shadow: none;
  }

  /* Keyboard focus has to clear the dark fill, not the pale alert behind it. */
  &&:focus-visible {
    outline: 2px solid #fff;
    outline-offset: -4px;
  }
`;
